import React from 'react';
import { Star, Quote } from 'lucide-react';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: 'Dr. Zia Ur Rehman',
      role: 'Professor of Computer Science',
      school: 'Avior School',
      content: 'tadriso has transformed how I teach. The interactive features and analytics help me understand exactly where my students need support.',
      rating: 5,
      avatar: 'ZR'
    },
    
    {
      name: 'Dr. Emily Bowman',
      role: 'Online Course Creator',
      school: 'Independent Educator',
      content: 'The course creation tools are fantastic. I can easily create engaging content and track student progress in real-time.',
      rating: 5,
      avatar: 'EB'
    },
    {
      name: 'Professor Muhammad Imran',
      role: 'College Principal',
      school: 'Dean College',
      content: 'Our student engagement has increased by 40% since implementing tadriso. The platform is intuitive and our teachers love it.',
      rating: 5,
      avatar: 'PI'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Loved by educators worldwide
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See what teachers, professors, and administrators are saying about tadriso
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              {/* Quote Icon */}
              <div className="mb-6">
                <Quote size={32} className="text-primary-600 opacity-50" />
              </div>

              {/* Rating */}
              <div className="flex items-center mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={20} className="text-yellow-400 fill-current" />
                ))}
              </div>

              {/* Content */}
              <p className="text-gray-700 leading-relaxed mb-6">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center">
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary-600 font-semibold text-sm">
                    {testimonial.avatar}
                  </span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-600">
                    {testimonial.role}
                  </p>
                  <p className="text-sm text-gray-500">
                    {testimonial.school}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-3xl md:text-4xl font-bold text-primary-600 mb-2">
              10,000+
            </div>
            <div className="text-gray-600">Active Educators</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-bold text-primary-600 mb-2">
              500+
            </div>
            <div className="text-gray-600">Schools & Universities</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-bold text-primary-600 mb-2">
              1M+
            </div>
            <div className="text-gray-600">Students Engaged</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-bold text-primary-600 mb-2">
              99.9%
            </div>
            <div className="text-gray-600">Uptime Guarantee</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 